export default __webpack_public_path__ + "static/media/p3.f25d83bc.jpeg";